import { Controller } from '@hotwired/stimulus'
import 'daterangepicker'
import moment from 'moment'

export default class extends Controller {
  static values = {
    applyLabel: { type: String, default: 'Apply' },
    format: { type: String, default: 'DD MMM YYYY' },
    cancelLabel: { type: String, default: 'Clear' },
    customRangeLabel: { type: String, default: 'Custom Range' },
    yearToDateLabel: { type: String, default: 'Year to Date' },
    weekToDateLabel: { type: String, default: 'Week to Date' },
    lastWeekLabel: { type: String, default: 'Last Week' },
    lastMonthLabel: { type: String, default: 'Last Month' },
    lastYearLabel: { type: String, default: 'Last Year' },
    allTimeLabel: { type: String, default: 'All Time' }
  }

  connect () {
    moment.locale(this.currentMomentLocale())
    const localeData = moment.localeData()

    $(this.element).daterangepicker({
      linkedCalendars: false,
      startDate: moment().startOf('year'),
      endDate: moment(),
      locale: {
        applyLabel: this.applyLabelValue,
        format: this.formatValue,
        cancelLabel: this.cancelLabelValue,
        customRangeLabel: this.customRangeLabelValue,
        daysOfWeek: localeData.weekdaysMin(),
        monthNames: localeData.months(),
        firstDay: localeData.firstDayOfWeek()
      },
      cancelButtonClasses: 'btn-dark',
      ranges: {
        [this.yearToDateLabelValue]: [moment().startOf('year'), moment()],
        [this.weekToDateLabelValue]: [moment().isoWeekday(1), moment()],
        [this.lastWeekLabelValue]: [moment().subtract(1, 'week').isoWeekday(1), moment().subtract(1, 'week').isoWeekday(7)],
        [this.lastMonthLabelValue]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        [this.lastYearLabelValue]: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
        [this.allTimeLabelValue]: [moment('2010-01-01'), moment()]
      },
      alwaysShowCalendars: true,
      opens: 'left'
    }, (_start, _end, label) => {
      this.updateInput($(this.element).data('daterangepicker').startDate.format(this.formatValue) + ' - ' + $(this.element).data('daterangepicker').endDate.format(this.formatValue))

      const event = new Event('daterangepicker.change', { bubbles: true })
      event.daterangeLabel = label

      this.element.dispatchEvent(event)
    })
  }

  disconnect () {
    // Disconnect the Handle Input Functions
    $(this.element).off(
      'apply.daterangepicker'
    ).off(
      'cancel.daterangepicker'
    )
  }

  updateInput (value) {
    $(this.element).val(value)
  }

  currentMomentLocale () {
    const locale = document.documentElement.lang.toLowerCase()

    if (locale === 'zh-cn') {
      return 'zh-cn'
    }

    return 'en'
  }
}
